export default __webpack_public_path__ + "img/shape.969c24a9.svg";